import React from "react";
import CONSTANT from "../../constants/Constant";
import styles from "../shared/stepbar/StepBar.module.css";

const StepBar = (props) => {
    let { groups, isCompleted, isShowFullName = true, showName=true } = props
    groups = groups.filter(group => group.key !== CONSTANT.ASSESSMENT_GROUP.OUTCOME_ASSESSMENT.key)

    const getStyle = () => {
        if(isShowFullName) return styles['stepbar__width--normal'];
        return styles['stepbar__width--my-assessment'];
    }

    return(
        <ol className={`${styles.stepbar} ${getStyle()}`}>
            {groups.map(group =>
                <li key={group.key} className={`${styles['stepbar__item']} ${isCompleted[group.key] ? styles['stepbar__item--complete'] : ''}`} data-step={group.name[0]}>
                    {showName ? `${isShowFullName ? group.name: group.midName}` : ""}
                </li>)}
        </ol>
    )
}

export default StepBar;

